var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_c('div',[(_vm.icon !== '')?_c('v-icon',{class:_vm.iconclass},[_vm._v(_vm._s(_vm.icon))]):_vm._e()],1),_c('div',{class:_vm.dynamicClass},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }